"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Google = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M12.1300001,19 C8.71470521,19 6,16.2852416 6,12.8699999 C6,9.4547582 8.71470521,6.73999977 12.1300001,6.73999977 C13.793874,6.73999977 15.1950002,7.35298914 16.2458315,8.40387367 L14.5819576,9.98014725 C14.1441156,9.54230531 13.3559788,9.01686304 12.1299469,9.01686304 C10.0282843,9.01686304 8.36441037,10.768284 8.36441037,12.8699999 C8.36441037,14.9717157 10.0282843,16.7231367 12.1299469,16.7231367 C14.5819576,16.7231367 15.4576415,14.9717157 15.6327889,14.0959786 L12.1299469,14.0959786 L12.1299469,11.9942628 L17.9096522,11.9942628 C17.9972525,12.3445576 17.9972525,12.6072521 17.9972525,13.0451473 C17.9973057,16.5479893 15.6328421,19 12.1300001,19 Z" })));
};
Google.displayName = 'Google';
exports.default = Google;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Google.js.map